export * from './IconKernFilled';
